.usa-map-container {
    color: var(--off-white-dk);
    position: relative;
}

.hover-container {
    position: absolute;
}
